import React from "react";
import { compose, branch } from "recompose";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { fetchApi } from "core/api/hoc";
import { fetchUserDataApi, isAuthenticated } from "../selectors";
import { fetchUserData } from "../api";

export default Component =>
  compose(
    connect(
      createStructuredSelector({
        isAuthenticated
      })
    ),
    branch(
      props => props.isAuthenticated,
      fetchApi(fetchUserData, ({ match }) => ({
        payload: {
          backUrl: match.url
        },
        selector: fetchUserDataApi,
        sync: true,
        key: "userDataApi"
      }))
    )
  )(({ userDataApi, isAuthenticated, ...props }) => <Component {...props} />);



// WEBPACK FOOTER //
// ./src/modules/user/auth/hoc/withUserData.js